<template>
  <v-app-bar
    :class="{ collapsed }"
    class="header"
    app
    :height="headerHeight"
    color="white"
    elevation="0"
  >
    <div class="header-top">
      <div class="header-start">
        <a href="https://campusmoviefest.com/" target="_blank">
          <div class="header-logo" aria-label="Campus Movie Fest"></div>
        </a>
      </div>
      <HeaderNav />
      <div class="header-end">
        <v-btn
          @click="$emit('input', !value)"
          icon
          class="sidebar-drawer"
          elevation="0"
        >
          <v-icon color="primary">
            {{ value ? "$sidebar_close" : "$menu" }}
          </v-icon>
        </v-btn>
      </div>
    </div>
    <div class="header-bottom">
      <TerminusHeader :collapsed="collapsed" />
    </div>
  </v-app-bar>
</template>

<script>
import HeaderNav from "./Header/HeaderNav";

export default {
  components: { HeaderNav },
  props: {
    collapsed: Boolean,
    value: Boolean
  },
  computed: {
    rootUrl() {
      return `/${this.activePage?.slug || ""}`;
    },
    headerHeight() {
      return this.collapsed ? 84 : 154;
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/styles/variables.scss";

.header::v-deep {
  .v-toolbar__content {
    flex-direction: column;
    padding: 0;
  }
}

.header {
  transition: 0.3s;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15) !important;

  &::v-deep .v-toolbar__content {
    transition: 0.3s;
  }

  &-top,
  &-bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  &-top {
    padding: 0 120px;
    background: $cmf-lightgray;
    transition: 0.3s;
    margin-top: 0px;
    min-height: 70px;
  }
}

.header-start a {
  text-decoration: none;
}

.header-start {
  display: flex;
  align-items: center;
  padding: 20px 20px 20px 0;
}

.header.collapsed {
  .header-top {
    margin-top: -70px;
  }

  .header-start a {
    text-decoration: none;
  }

  .header-start {
    padding: 20px 20px 20px 0;
  }
  .header-end {
    padding: 10px 0 10px 10px;
  }
}

.header-logo {
  width: 283px;
  height: 30px;
  background-image: url("~@/assets/logo_header.svg");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.header-label {
  font-family: "Pitch";
  font-weight: 600;
  font-size: 18px;
  letter-spacing: -0.04em;
  line-height: 17px;
  margin-left: 0.8em;
}

.header-end {
  display: none;
}

.sidebar-drawer {
  display: none;
}
@media screen and (max-width: 1264px) {
  .header::v-deep {
    .v-toolbar__content {
      padding: 0;
      .header-top {
        padding: 0 56px;
      }
    }
  }
}
@media screen and (max-width: 960px) {
  .header::v-deep {
    .v-toolbar__content {
      padding: 0;
      .header-top {
        padding: 0 13px 0 20px;
      }
    }
  }
  .header-logo {
    width: 225px;
  }

  .sidebar-drawer {
    display: block !important;
  }

  .header-start {
    justify-content: space-between;
  }

  .header-start,
  .header-end {
    display: flex;
    align-items: center;
  }

  .header-end {
    padding-right: 0 !important;
  }
}
</style>
